/*       */

import { gql } from '@apollo/client';

export default gql`
    mutation updateHookActionMutation($record: EntityUpdateInput!) {
        result: updateEntity(record: $record) {
            id
            type
        }
    }
`;
